import CSS from './styles.module.css'

// Animate on Scroll
import AOS from 'aos'
import 'aos/dist/aos.css'
import { useEffect } from 'react'
import ActionBoxCard from '../ActionBoxCard/ActionBoxCTA'

const WhyRecootySection = () => {
  useEffect(() => {
    AOS.init({ duration: 500, delay: 0 })
  }, [])

  return (
    <div className={CSS.MoreToolsContainer} data-aos="fade-up">
      <div className={CSS.MoreTools}>
        <div className={CSS.Heading}>
          <h3>Benefits of Recooty’s AI tool for interview questions </h3>
          {/* <p>
            Our tool is more than just a writer, it's a strategic partner in
            your hiring process. We’ve built a system that delivers tangible
            results.
          </p> */}
        </div>
        <div className={CSS.MTContainer}>
          <div className={CSS.ActionBox}>
            <div className={CSS.ActionSubBox}>
              <ActionBoxCard
                icon="trending_up"
                heading="Precision-Tailored Questions"
                content={
                  <>
                    Move beyond one-size-fits-all interviews. Generate questions
                    that
                    <br /> are highly specific to the job role, industry, and
                    required skill level
                  </>
                }
                button="Try for free"
                link="https://recooty.com/tools/hr-email-template-generator/"
                linkTarget="_blank"
                // className={CSS.ActionBox3}
              />
              <ActionBoxCard
                icon="edit_document"
                heading="Significant Time Savings"
                content="Drastically reduce your interview preparation time. Our tool quickly produces a comprehensive list of relevant questions"
                button="Try for free"
                link="https://recooty.com/tools/interview-question-generator/"
                linkTarget="_blank"
              />

              <ActionBoxCard
                icon="target"
                heading="Comprehensive Candidate Vetting"
                content="Access a diverse repository of question types, ensuring a thorough assessment of every candidate across all essential criteria."
              />
              <ActionBoxCard
                icon="diversity_3"
                heading="Instant Access, No Barriers"
                content="Begin using the tool immediately without the need for any sign-up or registration. It's hassle-free and instantly available."
              />
              {/* <ActionBoxCard
                icon="business_center"
                heading="Aligned with 100+ Industries & AI ATS"
                content="Our job description builder is fine-tuned for over 100 industries and is designed to be compatible with modern Applicant Tracking Systems (AI ATS), ensuring your JD gets seen by the right people."
              /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WhyRecootySection
